export function trackReportLog(eventname, ext) {
  window._fas &&
    window._fas.setCustomTrack({
      eventname,
      ext
    })
}
